import React from 'react';
import Icon from './Icon';

const InfoIcon = (props) => (
    <Icon {...props}>
        <path
            d="M6.5 4H18.5V20H6.5A2.5 2.5 0 0 1 4 17.5V6.5A2.5 2.5 0 0 1 6.5 4ZM4 17.5A2.5 2.5 0 0 1 6.5 15H18.5M8 8H14"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default InfoIcon;